import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto max-w-page px-4 md:px-8 py-20 md:py-28 text-center">
      <span className="mx-auto w-16 h-16 rounded-full bg-background-100 border border-background-300/60 flex items-center justify-center text-primary-400">
        <i className="ri-moon-foggy-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading font-extrabold text-4xl md:text-6xl text-foreground-950">404</h1>
      <h2 className="mt-3 font-heading font-bold text-lg md:text-xl text-foreground-900">这个午夜页面还没有内容</h2>
      <p className="mt-2 text-sm text-foreground-600">
        你访问的路径 <span className="font-mono text-foreground-800">{location.pathname}</span> 不存在或已被移除。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-background-200/80 border border-background-300/70 text-foreground-950 text-sm font-medium hover:border-primary-500/60 transition-colors whitespace-nowrap"
        >
          <i className="ri-compass-3-line"></i>
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}